<template>
  <div :class="{english:lang=='EN'}">
    <div class="hidden-xs">
      <div class="group-net" ref="groupNet">
        <div class="nanjing net-sign wow fadeInUp" @mouseenter="nanjing=true" @mouseleave="nanjing=false"
             style="z-index: 13;">
          <span class="title" style="z-index: 13;">{{$t('home.nanjing')}}</span>
<!--          <div class="left-arrow" v-if="nanjing"></div>-->
<!--          <div class="box-msg noneBox" v-if="nanjing">-->
<!--            <div class="none">{{$t('home.none')}}</div>-->
<!--          </div>-->
        </div>
        <div class="beijing net-sign wow fadeInUp" @mouseenter="beijing=true" @mouseleave="beijing=false"
             style="z-index: 13;">
          <span class="title" style="z-index: 13;">{{$t('home.beijing')}}</span>
<!--          <div class="left-arrow" v-if="beijing"></div>-->
<!--          <div class="box-msg noneBox" v-if="beijing">-->
<!--            <div class="none">{{$t('home.none')}}</div>-->
<!--          </div>-->
        </div>
        <div class="shanghai net-sign wow fadeInUp" @mouseenter="shanghai=true" @mouseleave="shanghai=false"
             style="z-index: 11;">
          <span class="title" style="z-index: 11;">{{$t('home.shanghai')}}</span>
<!--          <div class="left-arrow" v-if="shanghai"></div>-->
<!--          <div class="box-msg noneBox" v-if="shanghai">-->
<!--            <div class="none">{{$t('home.none')}}</div>-->
<!--          </div>-->
        </div>
        <div class="chongqing net-sign wow fadeInUp" @mouseenter="chongqing=true" @mouseleave="chongqing=false"
             style="z-index: 16;">
          <span class="title" style="z-index: 16;">{{$t('home.chongqing')}}</span>
<!--          <div class="left-arrow" v-if="chongqing"></div>-->
<!--          <div class="box-msg noneBox" v-if="chongqing">-->
<!--            <div class="none">{{$t('home.none')}}</div>-->
<!--          </div>-->
        </div>
        <div class="shenzhen net-sign wow fadeInUp" @mouseenter="shenzhen=true" @mouseleave="shenzhen=false"
             style="z-index: 11;">
          <span class="title" style="z-index: 11;">{{$t('home.shenzhen')}}</span>
<!--          <div class="left-arrow" v-if="shenzhen"></div>-->
<!--          <div class="box-msg noneBox" v-if="shenzhen">-->
<!--            <div class="none">{{$t('home.none')}}</div>-->
<!--          </div>-->
        </div>
        <div class="yantai net-sign wow fadeInUp" @mouseenter="showYanTai=true" @mouseleave="showYanTai=false"
             style="z-index: 11;">
          <span class="title" style="z-index: 11;">{{$t('home.yantai')}}</span>
<!--          <div class="left-arrow" v-if="showYanTai"></div>-->
<!--          <div class="box-msg" v-if="showYanTai">-->
<!--            <p>{{$t('home.message8.message80')}}</p>-->
<!--            <div>-->
<!--              <img class="address" src="../../../assets/img/mainpage/icon_address.png"/>-->
<!--              <span>{{$t('home.message8.message81')}}</span>-->
<!--            </div>-->
<!--            <div>-->
<!--              <img class="iphone" src="../../../assets/img/mainpage/icon_iphone.png"/>-->
<!--              <span style="line-height: 1.2rem;">+86 535 820 7090</span>-->
<!--            </div>-->
<!--            <div>-->
<!--              <img class="email" src="../../../assets/img/mainpage/icon_email.png"/>-->
<!--              <span>xqian@mindpointeye.com</span>-->
<!--            </div>-->
<!--          </div>-->
        </div>
        <div class="yangzhou net-sign wow fadeInUp" @mouseenter="showYangZhou=true" @mouseleave="showYangZhou=false"
             style="z-index: 12;">
          <span class="title" style="z-index: 12;">{{$t('home.yangzhou')}}</span>
<!--          <div class="left-arrow" v-if="showYangZhou"></div>-->
<!--          <div class="box-msg" v-if="showYangZhou">-->
<!--            <p>{{$t('home.message9.message90')}}</p>-->
<!--            <div>-->
<!--&lt;!&ndash;              <img class="address" src="../../../assets/img/mainpage/icon_address.png"/>&ndash;&gt;-->
<!--&lt;!&ndash;              <span>{{$t('home.message9.message91')}}</span>&ndash;&gt;-->
<!--            </div>-->
<!--            <div>-->
<!--&lt;!&ndash;              <img class="iphone" src="../../../assets/img/mainpage/icon_iphone.png"/>&ndash;&gt;-->
<!--&lt;!&ndash;              <span style="line-height: 1.2rem;">+86 514 8623 6888; 8623 6889</span>&ndash;&gt;-->
<!--            </div>-->
<!--            <div>-->
<!--&lt;!&ndash;              <img class="email" src="../../../assets/img/mainpage/icon_email.png"/>&ndash;&gt;-->
<!--&lt;!&ndash;              <span>xqian@mindpointeye.com</span>&ndash;&gt;-->
<!--            </div>-->
<!--          </div>-->
        </div>
        <div class="xinjiapo net-sign wow fadeInUp"
             @mouseenter="showXinJiaPo=true" @mouseleave="showXinJiaPo=false"
             style="z-index: 10;">
          <span class="title" style="z-index: 10;">{{$t('home.singapore')}}</span>
<!--          <div class="left-arrow" v-if="showXinJiaPo"></div>-->
<!--          <div class="box-msg" v-if="showXinJiaPo">-->
<!--            <p>{{$t('home.message10')}}</p>-->
<!--            <div>-->
<!--              <img class="address" src="../../../assets/img/mainpage/icon_address.png"/>-->
<!--              <span>{{$t('home.singaporetips')}}</span>-->
<!--            </div>-->
<!--            &lt;!&ndash;<div>-->
<!--              <img class="iphone" src="../../../assets/img/mainpage/icon_iphone.png"/>-->
<!--              <span style="line-height: 1.2rem;">0535-8207090</span>-->
<!--            </div>&ndash;&gt;-->
<!--            <div>-->
<!--              <img class="email" src="../../../assets/img/mainpage/icon_email.png"/>-->
<!--              <span>xqian@mindpointeye.com</span>-->
<!--            </div>-->
<!--          </div>-->
        </div>

        <img class="img-fluid" src="../../../assets/img/common/map.jpg"/>
        <div class="group-net-wrapper">
          <div class="group-net-introduction wow fadeInUp" data-wow-delay="0.2s">

            <div class="title">{{$t('home.network')}}</div>
            <div class="message">
              <span>{{$t('home.message7')}}</span>
            </div>
            <div class="operate">
              <div @click="openAboutUs" class="operate-button understand-more">{{$t('common.learnMore')}}
                <div class="unserstand-more-logo"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="visible-xs">
      <div class="group-net" ref="groupNet">
        <div class="yantai net-sign wow fadeInUp">
          <span class="title" style="z-index: 11;">{{$t('home.yantai')}}</span>
        </div>
        <div class="nanjing net-sign wow fadeInUp">
          <span class="title" style="z-index: 11;">{{$t('home.nanjing')}}</span>
        </div>
        <div class="yangzhou net-sign wow fadeInUp">
          <span class="title" style="z-index: 12;">{{$t('home.yangzhou')}}</span>
        </div>
        <div class="xinjiapo net-sign wow fadeInUp" style="z-index: 10;">
          <span class="title">{{$t('home.singapore')}}</span>
        </div>
        <div class="beijing net-sign wow fadeInUp" style="z-index: 10;">
          <span class="title">{{$t('home.beijing')}}</span>
        </div>
        <div class="shanghai net-sign wow fadeInUp" style="z-index: 10;">
          <span class="title">{{$t('home.shanghai')}}</span>
        </div>
        <div class="chongqing net-sign wow fadeInUp" style="z-index: 10;">
          <span class="title">{{$t('home.chongqing')}}</span>
        </div>
        <div class="shenzhen net-sign wow fadeInUp" style="z-index: 10;">
          <span class="title">{{$t('home.shenzhen')}}</span>
        </div>

        <img class="img-fluid banner-img" src="../../../assets/img/common/map-xs.jpg"/>
        <div class="group-net-wrapper-xs">
          <div class="group-net-introduction wow fadeInUp" data-wow-delay="0.2s">
            <div class="title">{{$t('home.network')}}</div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import {WOW} from 'wowjs'
  import {mapGetters} from 'vuex'

  export default {
    name: 'GroupNet',
    components: {},
    props: {},
    data() {
      return {
        showYanTai: false,
        showYangZhou: false,
        showXinJiaPo: false,
        beijing: false,
        shanghai: false,
        chongqing: false,
        shenzhen: false,
        nanjing:false,
      }
    },
    methods: {
      openAboutUs() {
        this.$router.push('AboutUs')
      }
    },
    mounted() {
      const wow = new WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: false,
        live: false
      })
      wow.init()
    },
    computed: {
      ...mapGetters(['lang']),
      getComponentName() {
        return '1'
      }
    }

  }
</script>

<style lang="scss" scoped>
  .group-net {
    width: 100%;
    height: auto;
    color: #FFFFFF;
    position: relative;

    .net-sign {
      display: flex;
      justify-content: center;
      position: absolute;

      .sign {
        display: flex;
        flex-direction: column;
        align-items: center;

        .dot {
          width: 0.525rem;
          height: 0.525rem;
          background: rgba(255, 255, 255, 1);
          border: 0px solid rgba(255, 255, 255, 1);
          border-radius: 50%;
        }

        .line {
          width: 0.075rem;
          height: 0.6rem;
          border: 1px solid #FFFFFF;
        }
      }

      .title {
        line-height: 0.225rem;
        margin-left: 0.225rem;
        font-family: Arial, Source Han Sans CN;
        font-weight: 400;
        z-index: 10;
      }

      .left-arrow {
        margin: -0.5rem 0 0 0.5rem;
        float: left;
        width: 0;
        height: 0;
        border-width: 0.6rem;
        border-style: solid;
        border-color: transparent #2B9EFF transparent transparent;
      }

      .box-msg {
        margin-top: -1.875rem;
        width: 20rem;
        height: auto;
        background: linear-gradient(90deg, rgba(43, 158, 255, 1) 0%, rgba(50, 79, 255, 1) 100%);
        display: flex;
        flex-direction: column;
        padding: 0.75rem 1.5rem;
        z-index: 20;

        &.noneBox {
          width: 10rem;
        }

        img {
          margin-right: 0.75rem;
        }

        .address {
          width: 0.975rem;
          height: 1.125rem;
        }

        .iphone {
          width: 1.05rem;
          height: 1.05rem;
        }

        .email {
          width: 0.975rem;
          height: 0.75rem;
        }

        p {
          font-size: 1.2rem;
          font-weight: bold;
          font-family: "Microsoft YaHei";
        }

        div {
          display: flex;
          justify-content: left;
          margin: 0.375rem 0.75rem;
          font-size: 0.75rem;

          &.none {
            font-size: 1.25rem;
            // font-weight:500;
          }

          span {
            width: 15rem;
          }
        }
      }
    }

    .yantai {
      margin-left: 47.6%;
      margin-top: 13.2%;
    }
    .nanjing{
      margin-left: calc(45.8% - 0.8em);
      margin-top: 15.1%;
      @media screen and (min-width: 768px) and (max-width: 1200px) {
        margin-left: calc(45.8% - 1.1em);
      }
    }
    .yangzhou {
      margin-left: calc(49.5% - 0.8em);
      margin-top: 15.1%;
      @media screen and (min-width: 768px) and (max-width: 1200px) {
        margin-left: calc(49.5% - 1.1em);
      }
    }

    .xinjiapo {
      margin-left: 39.5%;
      margin-top: 23.7%;
    }

    .beijing {
      margin-left: calc(43% - 0.8em);
      margin-top: 13%;
      @media screen and (min-width: 768px) and (max-width: 1200px) {
        margin-left: calc(43% - 1.1em);
      }
    }

    .shanghai {
      margin-left: 49%;
      margin-top: 16%;
    }

    .chongqing {
      margin-left: calc(36.2% - 0.8em);
      margin-top: 15.8%;
    }

    .shenzhen {
      margin-top: 18%;
      margin-left: 42.9%;
    }

    .group-net-wrapper {
      width: 100%;
      display: flex;
      align-items: center;
      position: absolute;
      // margin-top: -23%;
      top:50%;
      transform: translate(0,-50%);
      color: #FFFFFF;

      .group-net-introduction {
        display: flex;
        flex-direction: column;
        margin-left: 62.79%;
        max-width: 37%;
        .title {
          height: 3.75rem;
          font-size: 3rem;
          font-family: Arial, Source Han Sans CN;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          letter-spacing: 0.25rem;
          line-height: 4.38rem;
          letter-spacing: 0.25rem;
        }


        .underline {
          max-width: 9.75rem;
          margin-top: 1.5rem;
        }

        .message {
          margin-top: 5%;
          font-size: 0.9rem;
          font-family: Arial, Source Han Sans CN;
          font-weight: 300;
          color: rgba(255, 255, 255, 1);
          line-height: 2rem;
          max-width: 30rem;

          span {
            display: block;
          }
        }

        .operate {
          display: flex;
          justify-content: left;

          .operate-button {
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            width: 9rem;
            height: 2.7rem;
            margin: 2.25rem 1.5rem 0rem 0rem;
          }

          .understand-more {
            background: url("../../../assets/img/mainpage/button01.png") no-repeat;
            background-size: 100%;

            .unserstand-more-logo {
              background: url("../../../assets/img/mainpage/Arrow.png") no-repeat;
              background-size: 100%;
              width: 1.21rem;
              height: 0.525rem;
              margin-left: 0.375rem;
            }
          }

          .understand-more:hover {
            background: url("../../../assets/img/mainpage/button01_active.png") no-repeat;
            background-size: 100%;
          }
        }
      }
    }
  }

  .visible-xs {
    .group-net {
      width: 100%;
      overflow: hidden;
      position: relative;

      .banner-img {
        width: 100%;
      }

      .net-sign {
        display: flex;
        justify-content: center;
        position: absolute;

        .sign {
          display: flex;
          flex-direction: column;
          align-items: center;

          .dot {
            width: 0.525rem;
            height: 0.525rem;
            background: rgba(255, 255, 255, 1);
            border: 0px solid rgba(255, 255, 255, 1);
            border-radius: 50%;
          }

          .line {
            width: 0.075rem;
            height: 0.6rem;
            border: 1px solid #FFFFFF;
          }
        }

        .title {
          height: 1rem;
          line-height: 0.225rem;
          margin-left: 0.225rem;
          font-family: Arial, Source Han Sans CN;
          font-weight: 400;
          font-size: 0.8rem;
          z-index: 10;
        }

        .left-arrow {
          margin: -0.3rem 0 0 -0.3rem;
          float: left;
          width: 0;
          height: 0;
          border-width: 0.6rem;
          border-style: solid;
          border-color: transparent #2B9EFF transparent transparent;
        }

        .box-msg {
          margin-top: -1.875rem;
          width: 17.25rem;
          height: 11.25rem;
          background: linear-gradient(90deg, rgba(43, 158, 255, 1) 0%, rgba(50, 79, 255, 1) 100%);
          display: flex;
          flex-direction: column;
          padding: 0.75rem 1.5rem;
          z-index: 20;

          img {
            margin-right: 0.75rem;
          }

          .address {
            width: 0.975rem;
            height: 1.125rem;
          }

          .iphone {
            width: 1.05rem;
            height: 1.05rem;
          }

          .email {
            width: 0.975rem;
            height: 0.75rem;
          }

          p {
            font-size: 1.2rem;
            font-weight: bold;
            font-family: "Microsoft YaHei";
          }

          div {
            display: flex;
            justify-content: left;
            margin: 0.375rem 0.75rem;
            font-size: 0.75rem;
          }
        }
      }

      .yantai {
        margin-left: 81.4%;
        margin-top: 18.4%;
      }
         .nanjing {
        // margin-left: 73.5%;
        margin-top: 24%;
        margin-left: calc(78% - 1.3em);
      }

      .yangzhou {
        // margin-left: 73.5%;
        margin-top: 22.3%;
        margin-left: calc(86.0% - 1em);
      }

      .xinjiapo {
        margin-left:61.5%;
        margin-top: 45.5%;
      }

      .beijing {
        // margin-left:65.5%;
        margin-top: 18%;
        margin-left: calc(70.5% - 1.1em);
      }

      .shanghai {
        margin-left: 84.5%;
        margin-top: 25.3%;
      }

      .chongqing {
        margin-left:58.5%;
        margin-top: 25.2%;
      }

      .shenzhen {
        margin-top: 31%;
        margin-left: 69.65%;
      }

      .group-net-wrapper-xs {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        position: absolute;
        color: #FFFFFF;
        top: 0;
        margin-top: 1rem;

        .group-net-introduction {
          display: flex;
          text-align: center;
          flex-direction: column;
          width: 85%;

          .title {
            font-size: 1.5rem;
            font-family: Arial, Source Han Sans CN;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            letter-spacing: 0.25rem;
            line-height: 2.5rem;
            letter-spacing: 0.25rem;
          }

          .message {
            width: 45%;
            font-size: 0.7rem;
            font-family: Arial, Source Han Sans CN;
            font-weight: 300;
            color: rgba(255, 255, 255, 1);
            line-height: 1.5rem;

            span {
              display: block;
            }
          }

          .operate {
            display: flex;
            justify-content: left;

            .operate-button {
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              width: 6.45rem;
              height: 1.914rem;
              margin: 1rem 0rem;
            }

            .understand-more {
              background: url("../../../assets/img/mainpage/button01.png") no-repeat;
              background-size: contain;

              .unserstand-more-logo {
                background: url("../../../assets/img/mainpage/Arrow.png") no-repeat;
                background-size: contain;
                width: 0.726rem;
                height: 0.315rem;
                margin-left: 0.187rem;
              }
            }

            .understand-more:hover {
              background: url("../../../assets/img/mainpage/button01_active.png") no-repeat;
              background-size: contain;
            }
          }
        }
      }
    }
  }

  .english {
    .group-net .net-sign .box-msg.noneBox{
      width:14rem;
    }
    .title {
      letter-spacing: 0 !important;
    }

    .message {
      max-width: 80% !important;
      display: block;
    }

    .hidden-xs {
      .beijing {
        margin-left: calc(42.2% - 1.3em);
      }

      .yangzhou {
       margin-left: calc(49% - 0.8em);
      }
      .nanjing{
           margin-left: calc(44% - 0.5em);
         @media screen and (min-width: 768px) and (max-width: 1600px) {
           margin-left: calc(44% - 1.1em);
       }
      }
      .chongqing{
          margin-left: calc(34% - 0.8em);
           @media screen and (min-width: 768px) and (max-width: 1600px) {
           margin-left: calc(33% - 1.1em);
       }
      }
    }

    .visible-xs {
      .yantai {
        margin-left: 80.5% !important;
      }
      .yangzhou {
        margin-left:83.8%;
        margin-top:22%;
      }

      .xinjiapo {
        margin-left: 41.8% !important;
      }
      .nanjing{

        margin-left:65% !important;
      }
      .chongqing {
        margin-left:38.8%;
      }

      .beijing {
        margin-left: 62.5%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/home/GroupNet.vue